import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { CountryProvider } from './context/CountryContext';
import { installClickTracker } from './lib/tracker';
import HeroSpace from './components/HeroSpace';
import TransformSection from './components/TransformSection';
import FinalCTA from './components/FinalCTA';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import MalayLanding from './pages/MalayLanding';

const Landing = () => (
  <div className="bg-black min-h-screen">
    <HeroSpace />
    <TransformSection />
    <FinalCTA />
    <FAQSection />
    <Footer />
    <StickyCTA />
  </div>
);

function App() {
  useEffect(() => {
    try { installClickTracker(); } catch (e) { /* noop */ }
  }, []);

  return (
    <ErrorBoundary>
      <CountryProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/my" element={<MalayLanding />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/login" element={<AdminLogin />} />
            </Routes>
          </BrowserRouter>
        </div>
      </CountryProvider>
    </ErrorBoundary>
  );
}

export default App;
